import React, { useState } from "react";
import CustomerWarrantyList from "./Warrantylist";
import DealerAssign from "./Dealer-list";
import PendingDealerList from "../allusers/Pending-dealerlist";
import PendingcustomerList from "./customerdealerlist";

const Customers = () => {
  const [activeTab, setActiveTab] = useState("pending-list");

  

  return (
    <div style={styles.page}>
      {/* ✅ Tabs Header */}
   <div style={styles.tabs}>
  {/* <button
    style={activeTab === "customers-list" ? styles.activeTab : styles.tab}
    onClick={() => setActiveTab("customers-list")}
  >
    Warranty List
  </button>

  <button
    style={activeTab === "orders-list" ? styles.activeTab : styles.tab}
    onClick={() => setActiveTab("orders-list")}
  >
    Dealers List
  </button> */}

  <button
    style={activeTab === "pending-list" ? styles.activeTab : styles.tab}
    onClick={() => setActiveTab("pending-list")}
  >
    Customers List
  </button>
</div>

   

      {/* ✅ Table Container */}
<div style={styles.tableContainer}>
  {/* {activeTab === "customers-list" && <CustomerWarrantyList />} */}

  {/* {activeTab === "orders-list" && <DealerAssign />} */}

  {activeTab === "pending-list" && <PendingcustomerList />}
</div>

    </div>
  );
};

export default Customers;

/* ✅ Inline Styles */
const styles = {
  page: {
    padding: "12px 14px",
    background: "#fff",
    fontFamily: "Arial, sans-serif",
  },

  tabs: {
    display: "flex",
    gap: "10px",
    borderBottom: "1px solid #ddd",
    marginBottom: "10px",
  },

  tab: {
    padding: "8px 14px",
    border: "1px solid #dcdcdc",
    borderBottom: "none",
    background: "#f7f7f7",
    cursor: "pointer",
    fontSize: "13px",
    borderTopLeftRadius: "4px",
    borderTopRightRadius: "4px",
  },

  activeTab: {
    padding: "8px 14px",
    border: "1px solid #dcdcdc",
    borderBottom: "none",
    background: "#fff",
    cursor: "pointer",
    fontSize: "13px",
    borderTopLeftRadius: "4px",
    borderTopRightRadius: "4px",
    fontWeight: "bold",
    color: "#005487",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 4px",
  },

  title: {
    margin: 0,
    color: "#005487",
    fontSize: "20px",
    fontWeight: "bold",
  },

  searchInput: {
    width: "220px",
    padding: "6px 10px",
    border: "1px solid #ccc",
    borderRadius: "6px",
    outline: "none",
  },

  tableContainer: {
    border: "1px solid #ddd",
    borderRadius: "6px",
    overflow: "hidden",
    background: "#fff",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
  },

  th: {
    background: "#f2f2f2",
    padding: "10px",
    fontSize: "13px",
    textAlign: "left",
    borderBottom: "1px solid #ddd",
  },

  td: {
    padding: "10px",
    fontSize: "13px",
    borderBottom: "1px solid #eee",
  },

  noData: {
    textAlign: "center",
    padding: "14px",
    fontSize: "14px",
  },
};
